import Vue from 'vue';
import VueTheMask from 'vue-the-mask'
import VueSimpleAlert from "vue-simple-alert";

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

Vue.use(VueTheMask);
Vue.use(VueSimpleAlert);